import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../primitive/select";

import { getFieldError } from "./get-field-error";
import { useFieldContext } from "./form";

interface SelectItemOption {
  value: string;
  label: string;
}

interface FormSelectProps {
  items: SelectItemOption[];
  placeholder?: string;
  showErrorMessage?: boolean;
  className?: string;
}

function FormSelect({
  items,
  placeholder,
  showErrorMessage = true,
  className,
}: FormSelectProps) {
  const field = useFieldContext<string>();

  return (
    <div className="flex flex-col gap-2">
      <Select
        value={field.state.value ?? ""}
        onValueChange={(value) => field.handleChange(value)}
      >
        <SelectTrigger className={className}>
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {items.map((item) => (
            <SelectItem key={item.value} value={item.value}>
              {item.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showErrorMessage && field.state.meta.errors.length > 0 ? (
        <span className="text-sm text-destructive">
          {getFieldError(field.state.meta.errors[0])}
        </span>
      ) : null}
    </div>
  );
}

export { FormSelect };
export type { SelectItemOption as SelectItem };
